import { useFetchApi } from "src/ssc-api/useFetchApi";
import { CruiseQueryPageProps } from "src/templates/Cruise";
import { SpecialVoyageQueryPageProps } from "src/templates/NewSpecialVoyage";

export function useStaticCruise<
  T extends CruiseQueryPageProps | SpecialVoyageQueryPageProps
>(cruisePage: string | undefined) {
  const offerPageUrl = cruisePage
    ? `/page-data${cruisePage}/page-data.json`
    : undefined;
  const { status, data } = useFetchApi<{
    result: {
      data: T;
    };
  }>(offerPageUrl);

  return {
    status,
    staticData: data?.result?.data
  };
}
